function Relatorios() {
  return <h1>Página de Relatórios</h1>;
}
export default Relatorios;